module.exports = __webpack_public_path__ + "ca6af61cd20bf7802d1ea64e084ca3a0.pdf";